// extracted by mini-css-extract-plugin
export var typingIndicator = "_ib-0";